// Login e primeiro acesso (TELAS §Login). Sem tela de abertura: ou pede o código do primeiro acesso, ou pede usuário e
// senha. A mensagem de erro vem do servidor pronta pra ler.
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { api, ErroApi } from '../nucleo/api';
import { Marca } from '../layout';
import { Botao, Campo } from '../ui';

export type EstadoAuth = { configurado: boolean; entrou: boolean; usuario: string | null };

export function Entrar({ estado, aoEntrar }: { estado: EstadoAuth; aoEntrar: (usuario: string) => void }) {
  const navegar = useNavigate();
  const [codigo, setCodigo] = useState('');
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const primeiroAcesso = !estado.configurado;

  const enviar = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      const r = primeiroAcesso
        ? await api.post<{ usuario: string }>('/auth/configurar', { codigo: codigo.trim(), usuario: usuario.trim(), senha })
        : await api.post<{ usuario: string }>('/auth/entrar', { usuario: usuario.trim(), senha });
      aoEntrar(r.usuario);
      navegar('/');
    } catch (x) {
      setErro(x instanceof ErroApi ? x.message : 'não consegui entrar agora');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="flex h-full items-center justify-center bg-[radial-gradient(60%_50%_at_50%_0%,rgba(61,139,255,.10),transparent)] p-6">
      <form onSubmit={(e) => void enviar(e)} className="tela-entra w-[min(380px,100%)] rounded-[20px] border border-borda-2 bg-surface p-7 shadow-n3">
        {/* a marca: o X aceso aqui é só identidade (não há tempo real antes de entrar) */}
        <h1 className="mb-2 [&_.marca]:text-[22px]">
          <Marca vivo estatica />
        </h1>
        <p className="mb-6 text-[13px] text-muted">{primeiroAcesso ? 'primeiro acesso: use o código que está no servidor' : 'entre pra continuar'}</p>

        <div className="space-y-3">
          {primeiroAcesso && <Campo rotulo="código" value={codigo} onChange={(e) => setCodigo(e.target.value)} autoFocus autoComplete="off" />}
          <Campo rotulo="usuário" value={usuario} onChange={(e) => setUsuario(e.target.value)} autoComplete="username" autoFocus={!primeiroAcesso} />
          <Campo rotulo="senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} autoComplete={primeiroAcesso ? 'new-password' : 'current-password'} />
        </div>

        {erro && <p className="mt-3 rounded-[10px] bg-danger/10 px-3 py-2 text-[13px] text-danger">{erro}</p>}

        <Botao type="submit" variante="primario" carregando={enviando} className="mt-6 w-full">
          {primeiroAcesso ? 'criar acesso' : 'entrar'}
        </Botao>
      </form>
    </div>
  );
}
